module.exports = __webpack_public_path__ + "static/img/icon-1.0037be37.png";